var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"copy",on:{"click":function($event){return _setup.copyText(_setup.props.text)}}},[_vm._v("复制")])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }